export const language: any ={
    LabelLogin:"로그인",
    LabelForgotPw:"비밀번호 찾기",
    LabelSignUp:"회원가입",
    LabelRememberMe:"로그인 상태 유지",
    Or:"또는",
    Email:"이메일",
    Password:"비밀번호",
    LangKo:"한국어",
    LangEn:"영어",
    LangVi:"베트남어",
    LabelCondition:"약관동의",
    FullAgreement:"전체 동의",
    Next:"다음",
    PrivacyPolicy:`개인정보 처리방침 <span class="text-[#ff6741]">(필수)</span>`,
    TermOfUse:`이용약관 <label class="text-[#ff6741]">(필수)</label>`,
    VerifyPassword:"비밀번호 확인",
    PlaceHolderPassword:"영문+숫자+특수문자 8자리 이상 입력",
    DuplicateCheck:"중복확인",
    LabelIdEmail:"아이디 (이메일)",
    GN_02_MSG_01:"Phiên bản ứng dụng của bạn đã cũ. Vui lòng nâng cấp để tiếp tục sử dụng.",
    AU_02_MSG_02:"해당 이메일은 이미 시스템에 등록되어 있습니다. 다른 이메일을 사용해주세요.",
    AU_02_MSG_03:"사용 가능한 이메일입니다.",
    AU_02_MSG_01:"올바른 이메일 형식을 입력해주세요.",
    AU_01_MSG_01:"아이디 또는 비밀번호가 맞지 않습니다. 다시 시도해주세요.",
    AU_02_MSG_04:"사용 가능한 이메일을 확인해주세요.",
    AU_02_MSG_05:"영문, 숫자, 특수문자 포함 8자 이상으로 입력해주세요.",
    AU_02_MSG_06:"비밀번호가 일치하지 않습니다.",
    AU_03_MSG_01:"이메일을 정확히 입력해주세요.",
    AU_03_MSG_02:"해당 이메일은 시스템에 등록되어 있지 않습니다.",
    AU_03_MSG_04:"※ 인증 코드가 등록된 이메일로 전송되었습니다.",
    LabelRegisterComplete:"회원가입이 완료되었습니다!",
    LabelLoginToUseService:"로그인 후 서비스를 이용해보세요.",
    LabelDontRememberPassword:"비밀번호가 기억나지 않으세요?",
    LabelYouCanFindEmail:"이메일 인증을 통해 찾으실 수 있습니다.",
    LabelPasswordTemporarySendToEmail:"※ 가입하신 이메일로 임시 비밀번호를 보내드립니다.",
    SendVerifyNumber:"인증번호 전송",
    LabelCheckYourEmailForTemporaryPassword:"이메일에서 임시 비밀번호를 확인해주세요.",
    PlaceHolderTemporaryPassword:"임시 비밀번호 입력",
    LabelTemporaryPassword:"임시 비밀번호",
    // LabelYouCanResendItAfter:`비밀번호를 못받으셨나요? {time} 후 재전송 할 수 있습니다.`,
    LabelDidntReceiveYourPassword:`비밀번호를 못받으셨나요? `,
    LabelYouCanResendItAfter:`후 재전송 할 수 있습니다.`,
    LabelYouCanResendAgain:`재전송 할 수 있습니다.`,
    Confirm:`확인`,
    Resend:`재전송`,
    LabelResetPassword:"비밀번호 재설정",
    NewPassword:"새 비밀번호",
    ConfirmNewPassword:"새 비밀번호 확인",
    PlaceHolderConfirmPassword:"비밀번호 확인",
    CurrentPassword:"현재 비밀번호", //menu
    LanguageSetting:"언어 설정", //menu
    LeaveMembership:"회원 탈퇴", //menu
    LabelConfirmPasswordToLeaveMemberShip:"회원탈퇴 하기 위해 비밀번호를 확인하세요.", //menu
    LabelConfirmPasswordMeansYouAgreeAllContent:"비밀번호를 확인한 것은 모든 가이드 내용을 확인하고 이에 동의한다는 것을 의미합니다. ", //menu
    LabelCancelMembership:"회원 탈퇴하기", //menu
    LabelBeforeLeaveYouCheckedContent:"탈퇴 전 아래의 안내사항을 확인하시고 동의하기에 체크해주셔야 합니다.", //menu
    LabelAfterLeaveAllInfoWillRemove:"탈퇴 후 회원정보 및 이용기록은 모두 삭제되며, 다시 복구할 수 없습니다.", //menu
    LabelIHaveReadAndAgreeContent:"안내사항을 모두 확인하였으며 이에 동의합니다.", //menu
    ToUnsubscribe:"탈퇴하기", //menu
    LabelWouldYouWantLogout:"로그아웃 하시겠어요?", //menu
    ChangePassword:"비밀번호 변경", //menu
    Menu:"메뉴", //menu
    MenuLanguageSettings:"언어설정", //menu
    MenuPrivacyPolicy:"개인정보 처리방침", //menu
    MenuLogout:"로그아웃", //menu
    MenuLeaveMembership:"회원탈퇴", //menu
    LabelAreYouSureLeaveMembership:"정말 탈퇴하시겠습니까?", //menu
    LabelIfLeaveMembershipAllInfoWillRemove:"탈퇴하면 계정 정보가 삭제되어 복구할 수 없습니다.", //menu
    LabelPrivacyPolicy:"개인정보 처리방침",
    LabelTermOfUse:"이용약관",
    MI_02_MSG_01 : "현재 비밀번호가 정확하지 않습니다.",
    LabelModalLogin: `해당 기능을 이용하기 위해<br/>로그인 또는 회원가입하세요.`,
    LabelIdLogin: "아이디 로그인",
    LabelSnsApple: "Apple로 로그인",
    LabelSnsFacebook: "Facebook 로그인",
    LabelSnsGoogle: "Google 로그인",
    LabelItemLogin: "Hey! Cooker와 함께 다양한 기능을 탐방하려면<br/>로그인 또는 회원가입하세요.",
    LabelSnsEmail: "이메일 로그인",
    LoadingLogin: "잠시만 기다려주세요.",
    MenuNotificationSettings: "알림 설정", //menu
}